
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/match-booster/targeting-levels",
      function () {
        return require("private-next-pages/match-booster/targeting-levels.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/match-booster/targeting-levels"])
      });
    }
  